import { BTab } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBTab when migrating. */
export const EgBTab = createEgBootstrapProxy("EgBTab", BTab);
